module.exports = __webpack_public_path__ + "img/img12.de3fcfe6.svg";